import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useResolveComplaint = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);

    const onResolveComplaintDataError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while resolving complaint.',
        );
    };

    const onResolveComplaintDataSuccess = (callbackFn: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success(message || 'Complaint resolved successfully');
        callbackFn();
    };

    const resolveComplaint = (
        driverId: string, callbackFn: () => void,
    ) => {

        const url: HttpConfig = {
            // url: `ba/v1/drivers/verification/complaints/${driverId}/resolve`,
            url: `ba/v1/drivers/verification/${driverId}/approve-driver`,
            method: 'post',
            // data,
        };

        request(url, onResolveComplaintDataSuccess(callbackFn), setLoading, onResolveComplaintDataError);
    };

    return { resolveComplaint, loading };
};

export default useResolveComplaint;
